/* eslint-disable prettier/prettier */
const stage = {
  REDIRECT_LOGOUT_URL: 'https://dash.stagecliengo.com/login',
  API_URL: 'https://api.stagecliengo.com/1.0',
  CRM_URL: 'https://crm.stagecliengo.com',
  METRICS_API_URL: 'https://geniol-1b70ca157962.herokuapp.com',
  MFE_APP_GENIA_HOME: 'https://prod.d1txpjwjyslsew.amplifyapp.com',
  ZORDON_URL: 'https://stage-zordon-9e009c9b84c6.herokuapp.com/api',
  MFE_APP_REPORTS_URL: 'https://www.custom-report.stagecliengo.com/?r=advanced',
  MFE_APP_LIVE_URL: 'https://kanban.stagecliengo.com',
  MFE_APP_CAMPAIGNS_URL: 'https://www.campaigns.stagecliengo.com',
  MFE_IFRAME_CRM: 'https://crm.stagecliengo.com',
  MFE_APP_GENIA_CHATBOT_MODULE: 'https://chatbot-module.stagecliengo.com',
  MFE_IFRAME_COCOS: 'https://www.coquitos.stagecliengo.com',
  MFE_IFRAME_HSM: 'https://www.hsm-manager.stagecliengo.com',
  MFE_ACCOUNT: 'https://account.stagecliengo.com',
  SOCKET_NOTIFICATION_URL:
    'https://stage-socketia-64373bef850d.herokuapp.com/clients',
  SEGMENT_WRITE_KEY: process.env.STAGE_SEGMENT_WRITE_KEY,
  LAUNCHDARKLY_KEY: process.env.STAGE_LAUNCHDARKLY_KEY,
  IA_URL: 'https://stage-zordon-9e009c9b84c6.herokuapp.com/api/message/receive',
  MFE_TS_AI_REPORTS_URL:
    "https://appsmith.devcliengo.com/app/gpt-report-csat/d'50px'ashboard-6532697f36a60447071ed1f9?embed=true&companyId=",
  ADMIN_URL: 'https://app.stagecliengo.com/admin/companies',
  LIA_URL:
    'https://lw.stagecliengo.com/?companyId=5f7483667ca30a002aa543c6&websiteId=64a6e4c877d51f005df6513c',
  MFE_APP_DASHBOARD_URL: 'https://dashboard.stagecliengo.com',
  MFE_APP_AFFILIATES: 'https://www.partners-dashboard.stagecliengo.com',
  CLIENGO_APP_URL: 'https://app.stagecliengo.com',
  LW_URL: 'https://lw.stagecliengo.com',
  COOKIE_DOMAIN: '.stagecliengo.com',
  MFE_APP_SUBSCRIPTIONS_URL: 'https://subscriptions.stagecliengo.com',
  ONESIGNAL_APP_ID: 'b5019d30-a38a-4161-98eb-9ddb6fe41ad7',
  LOGIN_URL: 'https://login.stagecliengo.com',
};

export default stage;
